import type { UserLanguageSchema } from '@shape-construction/api/src-global/types';

export type Locale = UserLanguageSchema;

// Order matters: primary-tag fallback in detectLocale() picks the first match.
export const SUPPORTED_LOCALES: Locale[] = ['en', 'es-419', 'pt-PT', 'tr', 'de-DE', 'fr-FR', 'el-GR'];
export const DEFAULT_LOCALE: Locale = 'en';
